export default __webpack_public_path__ + "static/media/Front3.435ed957.png";